export default __webpack_public_path__ + "static/media/04-entrada-platinum.c85b6169.png";